export const triggerBasketEvent = () => {
  window.gtag("event", "userRegisterSuccess");
};

export const triggerConversionEvent = () => {
  window.gtag("event", "userDepositSuccess");
};

const OPENAI_PIXEL_ID = "GvcWNDrTcnyFHkJ1zgkfD3";
const OPENAI_PIXEL_SRC = "https://bzrcdn.openai.com/sdk/oaiq.min.js";

// Loaded from the bundle rather than as an inline <script> in index.html, so the
// snippet's source never sits in the DOM where it can surface as page text.
export const initOpenAIPixel = () => {
  try {
    if (typeof window === "undefined" || window.oaiq) return;

    const queue = function() {
      queue.q.push(arguments);
    };
    queue.q = [];
    window.oaiq = queue;

    const script = document.createElement("script");
    script.async = true;
    script.src = OPENAI_PIXEL_SRC;
    document.head.appendChild(script);

    window.oaiq("init", { pixelId: OPENAI_PIXEL_ID, debug: process.env.NODE_ENV !== "production" });
  } catch (err) {
    console.log(err);
  }
};

// The id is shared with the server event so OpenAI counts the signup once.
export const triggerOpenAIRegistrationCompleted = storeId => {
  try {
    if (typeof window === "undefined" || typeof window.oaiq !== "function" || !storeId) return;

    window.oaiq(
      "measure",
      "registration_completed",
      { type: "customer_action" },
      { event_id: `reg_${storeId}` }
    );
  } catch (err) {
    console.log(err);
  }
};
